import {mapActions} from "vuex";
import rateSelect from "@/components/features/rate-select/index.vue";

export default {
	name: "HomeWorkRate",
	props: {
		homeWork	: {
			required	: true,
			type		: Object
		}
	},
	components: {
		rateSelect,
	},
	created() {
		console.log('HomeWorkRate homeWork:');
		console.log(this.homeWork);
		console.log('');
	},
	computed: {
		allowShow(){
			if(this.homeWork.hideRating){
				if(this.homeWork.type == "text"){
					return true;
				}
				
				return false;
			}
			
			return true;
		},
		hasCreatedRate() {
			return !Array.isArray(this.homeWork.userRating.data)
		},
		value() {
			return this.hasCreatedRate ? this.homeWork.userRating.data.rating : null;
		},
		summary() {
			return this.homeWork.ratingSummary.data;
		}
	},
	methods: {
		...mapActions({
			createRate: 'coursesHomeWork/CREATE_RATE',
			updateRate: 'coursesHomeWork/UPDATE_RATE'
		}),
		async onValueChanged(rating) {
			try {
				if (this.hasCreatedRate) {
					await this.updateRate({
						courseId	: this.homeWork.courseId,
						moduleId	: this.homeWork.moduleId,
						homeWorkId	: this.homeWork.id,
						rateId		: this.homeWork.userRating.data.id,
						rating
					})
				} else {
					await this.createRate({
						courseId	: this.homeWork.courseId,
						moduleId	: this.homeWork.moduleId,
						homeWorkId	: this.homeWork.id,
						rating
					})
				}
				
				if (rating) {
					this.$emit('showCommentForm', !!rating)
				}
			} catch (e) {
				console.error(e.message);
			}
		}
	}
};
